
import {of as observableOf,  Observable } from 'rxjs';

import {refCount, map, catchError, publishReplay, mergeMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { WindowRefService } from './window-ref.service';
import { StorageRefService } from './storage-ref.service';


const ROLE_URL_API = `/wps/PruResource/headerinfo?${Date.now()}`;
const ROLE_URL_LOCAL = '/json/user-roles.json';
const ONEPIX_API = '/sec/onepix.jpg';
const ONEPIX_LOCAL = '/images/onepix.jpg';
const DEFAULT_UNAUTH_ROLE = {
  r: 'unauth',
  s: ''
} as any;

export interface UserRole {
  checkAuthStatus(domain: string): Observable<any>;
  getRoles(access: string, domain: string): Observable<any>;
}

@Injectable()
export class UserRoleService implements UserRole {
  private cachedRolesFromApi$: Observable<any>;
  public static isCustomer: boolean | null = null;
  public static readonly CUSTOMER_ROLE = {
    r: 'INDV_CUSTOMER',
    s: ''
  };

  constructor(
    public http: Http,
    public windowService: WindowRefService,
    public storageService: StorageRefService
  ) { }

  checkAuthStatus(domain: string): Observable<any> {
    const authUrl = /localhost/.test(domain) ? ONEPIX_LOCAL : ONEPIX_API;
    const checkAuthUrl = domain + authUrl;
    // console.log('checkAuthStatus', checkAuthUrl)
    if (this.windowService.nativeWindow['cachedstatusObservable']) {
      return this.windowService.nativeWindow['cachedstatusObservable'];
    }

    const statusObservable = this.http
      .get(checkAuthUrl, { withCredentials: true }).pipe(
      map(res => {
        const contentType = res.headers.get('Content-type');

        return contentType === 'image/jpeg' ? true : false;
      }),
      catchError(error => {
        return observableOf(error);
      }),
      publishReplay(1),
      refCount(),);
    this.windowService.nativeWindow['cachedstatusObservable'] = statusObservable;

    return statusObservable;
  }

  getRoles(access: string, domain: string): Observable<any> {
    const ROLE_URL = /localhost/.test(domain) ? ROLE_URL_LOCAL : ROLE_URL_API;
    const finalUrl = domain + ROLE_URL;

    let isAuth$: Observable<boolean>;
    if (access === 'unauth') {
      isAuth$ = observableOf(false);
    } else if (access === 'auth') {
      isAuth$ = observableOf(true);
    } else {
      isAuth$ = this.checkAuthStatus(domain);
    }

    return isAuth$.pipe(mergeMap(isAuthFlag => {
      let roles$: Observable<any>;
      if (!isAuthFlag) {
        roles$ = observableOf(DEFAULT_UNAUTH_ROLE);
      } else {
        if (UserRoleService.isCustomer) {
          roles$ = observableOf(UserRoleService.CUSTOMER_ROLE);
        } else {
          roles$ = this.getRolesFromApi(finalUrl);
        }
      }

      return roles$;
    }));
  }

  private getRolesFromApi(url: string): Observable<any> {
    let sessionStorageCache = this.storageService.getItem('userRoles');

    if (!this.cachedRolesFromApi$) {
      if (sessionStorageCache === null || sessionStorageCache === undefined) {
        this.cachedRolesFromApi$ = this.http
          .get(url, { withCredentials: true }).pipe(
          map((res: Response) => {
            sessionStorageCache = res.json();
            this.storageService.setItem('userRoles', JSON.stringify(sessionStorageCache));
            return sessionStorageCache;
          }),
          catchError(() => observableOf(DEFAULT_UNAUTH_ROLE)),
          publishReplay(1),
          refCount(),);
      } else {
        this.cachedRolesFromApi$ = observableOf(JSON.parse(sessionStorageCache));
      }
    }

    return this.cachedRolesFromApi$;
  }
}
